import styled from 'styled-components';
import { MaskOverlayProps } from './types';

export const StyledMask = styled.div<MaskOverlayProps>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(39, 39, 39, 0.8);
  border-radius: ${(props) => props.borderRadius || '8px'};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  padding: 16px;
`;

export const StyledLabel = styled.span`
  color: var(--Tokens-Text-High-contrast-Inverse, #fff);
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-family: var(--Typography-Font-Family-Heading, Inter);
  font-size: var(--Font-Size-H4, 28px);
  font-style: normal;
  font-weight: 700;
  line-height: var(--Line-Height-H4, 40px); /* 142.857% */
  text-align: center;
`;
